import React from "react";

const PageNotFound = () => {
  return (
    <div className="header">
      <p className="header-small">You've found a page that doesn't exist</p>
      <h1 className="header-large">404 Page Not Found</h1>
    </div>
  );
};

export default PageNotFound;
